"use client";

import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheLarderTheLand() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="234058" id="about-the-release" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_backdrop_glow.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_backdrop_glow.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_backdrop_glow.png-wvc-sizes" alt="" className="w-full h-full object-cover blur-3xl scale-110" loading="lazy" />
        <div className="absolute inset-0 bg-linear-to-b from-background via-transparent to-background" />
      </div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-[60vh] lg:min-h-[800px]">
        {}
        <div className="relative h-[50vh] lg:h-auto">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_studio_vibe.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_studio_vibe.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/glamour_kitty_studio_vibe.png-wvc-sizes" alt="Atmospheric studio lighting and musical equipment" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 sepia-50 hue-rotate-[280deg] saturate-150 transition-all duration-700" loading="lazy" />
        </div>

        {}
        <div className="flex flex-col justify-center p-8 md:p-16 lg:p-20 xl:p-24 bg-background">
          <div ref={ref} className={`max-w-xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="border-gradient-purple w-12 mb-8" />
            
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground mb-6 leading-tight tracking-tight">
              The Frequency
            </h2>
            
            <p className="font-serif text-muted-foreground text-lg md:text-xl leading-relaxed mb-10 italic">
              A sonic exploration of late-night energy and rhythmic precision. This release captures the raw essence of the underground, blending deep bass textures with ethereal melodies that resonate long after the track ends. It is more than music; it is a vibration designed for the collective consciousness of the dance floor.
            </p>
            
            <Button asChild variant="link" className="text-primary hover:text-primary/80 p-0 h-auto text-lg font-medium group">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}